var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    ref: "statistics-chart-applications",
    staticClass: "statistics-chart-applications"
  }, [_c('v-chart', _vm._b({
    key: _vm.key,
    staticClass: "statistics-chart-applications__chart"
  }, 'v-chart', {
    options: _vm.options
  }, false))], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }